
import { Injectable } from "@angular/core";
import { WholeHist } from 'src/app/services/api-service/hist/whole-hist';
import { WebApiClient } from "../../web-api-client.service";
import { WebApiService } from "../../web-api.service";
import { ValueTextPair, ValueTextPairNumberValue } from '../../../shared/models/value-text-pair';
import { HCRxCodes } from "./hcRxCodes";
import { Hist } from "src/app/hist/models/hist";
import { DateHelper } from "src/app/shared/helpers/date-helper";
import { SPCTreatDto } from "./spcTreatDto";
import { BehaviorSubject } from "rxjs";
import { HistCusDto } from "src/app/hist/rating-price/models/RatingPrice";
import { SpecialSameTreatRxDto } from "../val-addapp/special-sameTreat-dto";
import { DiscountPriorityDto } from "../register/discount-priority-dto";
import { CashierPreview, IPricingApi, PricingEditOpt, PricingEditOpt2, PricingInfo } from "./pricing-api";

@Injectable({
  providedIn: 'root'
})
export class PricingChiApi implements IPricingApi {
  api: WebApiService;
  /**editOptions 取得費用項目 */

  private editoptRatingPriceSubject: BehaviorSubject<PricingEditOpt> = new BehaviorSubject<PricingEditOpt>(null);
  get editoptRatingPrice$() {
    return this.editoptRatingPriceSubject.asObservable();
  }


  constructor(private apiClient: WebApiClient) {
    this.api = apiClient.createChineseService('Hist/RatingPrice');
    this.api.enableLoader = false;
  }


  /**
   * 取得費用項目
   */
  async GetEditOptions(isRefresh: boolean = false, regDate: Date = null): Promise<PricingEditOpt> {
    if (!this.editoptRatingPriceSubject.value || isRefresh) {
      let isoDate = regDate ? DateHelper.getIsoStringNoTimeZone(regDate) : null;
      const options = await this.api.get('GetEditOptions', { regDate: isoDate }).toPromise();
      this.editoptRatingPriceSubject.next(options);
    }

    return this.editoptRatingPriceSubject.value;
  }
  async GetEditOptions2(regDate: Date = null): Promise<PricingEditOpt2> {
    // return await Promise.resolve({Pharmarcist:[]});//改回有藥師
    let isoDate = regDate ? DateHelper.getIsoStringNoTimeZone(regDate) : null;
    return await this.api.get('GetEditOptions2', { regDate: isoDate }).toPromise();
  }
  /**
   * 取得費用項目
   */
  async GetPricing(date: Date): Promise<PricingInfo> {
    return this.api.get('GetPricing?histDate=' + date.toLocaleDateString()).toPromise<PricingInfo>();
  }

  async Preview(data: WholeHist, defaultCase: string = ''): Promise<CashierPreview> {
    return this.api.post('Preview?defaultCase=' + defaultCase , data).toPromise();
  }
  
  async GetHomeCareRxList(data: string[]): Promise<HCRxCodes[]> {
    return this.api.post('GetHomeCareRxList?', data).toPromise();
  }
  async GetCourseTreatmentData(patientId: number, icNo: string, date: Date, cusTp: string, histId: number, isqnoExt:string, isSpecial: boolean = false): Promise<HistCusDto> {
    var strdate = DateHelper.formatDateTime(date);

    // var sDate = format(strdate, 'yyyy-MM-dd HH:mm:ss');
    return await this.api.get(`GetCourseTreatmentData?patientId=${patientId}&icNo=${icNo}&date=${strdate}&cusTp=${cusTp}&histId=${histId}&isqnoExt=${isqnoExt|| ''}&isSpecial=${isSpecial}`).toPromise<HistCusDto>();
  }
//   async GetPriceingPHcsWord(dx:string): Promise<string> {
//     var codeArr= await this.api.post('GetPriceingPHcsWord?dx=' + dx,
//      {}).toPromise();
//      return codeArr[0] ?? ''
//  }
//   async GetAllSPCTreatData(): Promise<SPCTreatDto> {
//     return await this.api.get(`GetAllSPCTreatData`).toPromise<SPCTreatDto>();
//   }
//   async GetSpecialSameTreatRx(): Promise<SpecialSameTreatRxDto[]> {
//     return this.api.get('GetSpecialSameTreatRx').toPromise<SpecialSameTreatRxDto[]>();
//   }

}
